import { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import Select from "../Components/CommonCommponents/select/Select";
import { UploadOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import { useRef } from "react";
import { Button, Upload, Progress, Modal } from "antd";
import CandodateService from "../Service.js/CandidateService";
import { isEmpty } from "lodash";
import toast from "react-hot-toast";
import { useFetchAllDocumentTypes } from "../ServiceHooks/candidateHooks";

const DocumentUpload = (props) => {
  const { jobId } = useParams();
  const hiddenFileInput = useRef(null);
  const [fileName, setFileName] = useState();
  const [isActiveFile, setActiveFile] = useState(false);

  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //TODO: add params when API support arrives.
  const { data: documentTypes } = useFetchAllDocumentTypes({
    params: {},
  });

  const documentTypesOptions = useMemo(() => {
    if (isEmpty(documentTypes?.results)) return [];
    const options = documentTypes?.results?.map((item) => ({
      label: item.document_name,
      value: item.id,
    }));

    return options;
  }, [documentTypes]);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const { onChange: logoOnChange, ...otherLogoFieldItems } = register(
    "document",
    {
      required: "This field is required",
    }
  );
  const handleFile = (e) => {
    console.log("tedte", e.target.files[0]);
    setFileName(e.target.files[0]);
    // setUpladedImage(URL.createObjectURL(e.target.files[0]));
    setActiveFile(true);
    //logoOnChange(e)
    setValue("document", e.target.files[0]);
    console.log("asdasd");
  };

  const onSubmit = async (data) => {
    console.log("asccf", data);
    const params = {
      candidate_id: props?.candidateId,
    };
    await CandodateService.uploadDocument(
      data,
      fileName,
      props?.candidateId,
      params
    )
      .then(
        (response) => {
          toast.success("Successfully Added!");
          props.close();
          //props.close();
        },
        (error) => {
          console.log("erroe", error?.response?.data?.error_info);
          const errorsObj = error?.response?.data?.error_info;
          console.log("objerror", Object.keys(errorsObj));
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });

    // .then(
    //   (oResponse) => {
    //     console.log("oResponse", oResponse);
    //     toast.success("Successfully Added!");
    //     props.close();
    //   },
    //   (error) => {
    //     console.log("loginError", error);
    //   }
    // )
    // .catch((err) => {
    //   console.log(err);
    //   toast.error("Failed To Add");
    // });
  };
  return (
    <>
      <div>
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
          <div className="">
            <div class="w-full px-4 mt-8">
              <Select
                name="document_type"
                placeholder="Select"
                label="Select Your Document"
                control={control}
                options={documentTypesOptions}
                rules={{
                  required: "At Least 1 Option must be chosen",
                }}
              />
            </div>
            <div className="flex mt-10">
              <div className="px-4">
                <p className="text-black font-poppins text-base font-normal">
                  Upload Your Document
                </p>
                <div className="mt-4">
                  <button
                    type="button"
                    className=" w-full p-3 rounded-full border border-black  text-base "
                    onClick={handleClick}
                  >
                    Upload Document
                  </button>
                  <input
                    type="file"
                    name="document"
                    multiple
                    {...register("document", {
                      required: "This field is required",
                    })}
                    {...otherLogoFieldItems}
                    //control={control}
                    onChange={handleFile}
                    ref={hiddenFileInput}
                    accept=".doc, .docx, .pdf, .rtf"
                    style={{ display: "none" }} // Make the file input element invisible
                  />
                  {errors && errors.document && (
                    <p className="text-[#ff4d4f] text-sm font-normal text-start mt-2 w-full">
                      {errors.document.message}
                    </p>
                  )}
                </div>
              </div>
              {isActiveFile && (
                <div className="flex flex-wrap  mt-12 mx-4">
                  <p className="text-body3 mt-3 px-2">
                    {fileName ? fileName?.name : ""}
                  </p>
                </div>
              )}
            </div>
            <div className="flex justify-end mt-8 mb-6">
              <div className="flex flex-wrap justify-between">
                <div className="px-4">
                  <Button
                    className="rounded-full border border-solid border-black text-black "
                    onClick={() => props.close()}
                  >
                    Cancel
                  </Button>
                </div>
                <div className="">
                  <Button
                    htmlType="submit"
                    type="submit"
                    className="rounded-full border border-solid border-black text-white bg-[#0A0A0A]"
                    //onClick={showDrawer}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default DocumentUpload;
